export const searchOptions = {
  keys: ['brandDescription'],
  minMatchCharLength: 1,
  threshold: 0.4,
  distance: 40,
};
